export default {"src":"/_next/static/media/card-notifications.4f545aa3.svg","height":44,"width":59,"blurWidth":0,"blurHeight":0};